<template>
  <div>
    <Navbar></Navbar>
    <div class="content">
      <div class="section_1">
      <div class="title _t">
        Contact Us
      </div>
      <div class="list-info">
        <div class="item">
          <div class="img">
            <img style="width: 0.57rem;" src="@/assets/2.0/icon-05.svg" />
          </div>
          <div class="text">
            <p>Phone:  ＋1 (858) 366-3765</p>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img style="width: 0.54rem;" src="@/assets/2.0/icon-06.svg" />
          </div>
          <div class="text">
            <p>Address: 9920 Pacific Heights Blvd,</p>
              <p>One Pacific Heights, Suite 410,</p>
                <p>San Diego, CA 92121</p>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img style="width: 0.60rem;"  src="@/assets/2.0/icon-07.svg" />
          </div>
          <div class="text">
            <p>Email: support@smwmed.com</p>
          </div>
        </div>
      </div>
    </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";


export default {
  name: "index",
  components: { Navbar,FooterDom },
  data() {
    return {

    };
  },
  created() {

  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  font-size: 0;
  ._t {
    font-size: 0.7rem;
    color: #000;
  }
  ._p{
    font-size: 0.22rem;
    color: #000;
  }

  .section_1{
  width: 100%;
  padding: 0 0.84rem;
  background: #ECEEEF;

  .title{
    color: #4FC78B;
    padding-top: 0.80rem;
    text-align: center;
    margin-bottom: 1.20rem;
  }
  .list-info{
    display: flex;
    justify-content: center;
    padding-bottom: 120px;
    flex-direction: column;
    .item{
      border-bottom: 1px dashed #494A4A;
      padding: 0.74rem 0 0.74rem 0;
      display: flex;
      align-items: center;
      &:last-child{
        border-bottom: none;
      }
      .img{

        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.78rem;
      }
      .text{
        font-size: .28rem;
        p{
          margin-bottom: .1rem;
        }
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/support.vue